import axios from 'axios';

export default {
  namespaced: true,
  state: () => ({
    options: [],
    loading: false,
    invalidated: false,
    lastLoadedAt: 0,
    inFlight: null, // Promise активного запроса
  }),
  getters: {
    options: s => s.options,
    loading: s => s.loading,
  },
  mutations: {
    setLoading(s, v) { s.loading = v; },
    setOptions(s, list) {
      s.options = list;
      s.invalidated = false;
      s.lastLoadedAt = Date.now();
    },
    invalidate(s) { s.invalidated = true; },
    setInFlight(s, p) { s.inFlight = p; },
  },
  actions: {
    async fetch({ state, commit }, { force = false } = {}) {
      // 1) если уже есть активный запрос — вернём его
      if (state.inFlight) return state.inFlight;

      // 2) TTL и кэш
      const freshEnough = Date.now() - state.lastLoadedAt < 15000; // 15s
      if (!force && state.options.length && freshEnough && !state.invalidated) return;

      commit('setLoading', true);
      const req = axios.get('/api/admin/projects-tree');
      commit('setInFlight', req);

      try {
        const { data } = await req;
        const mapped = (data || []).map(g => ({
          label: g.name,
          value: Number(g.id),
          children: (g.projects || []).map(p => ({ label: p.name, value: Number(p.id) }))
        }));

        // 3) не коммитим, если массив не изменился
        const same = JSON.stringify(mapped) === JSON.stringify(state.options);
        if (!same) commit('setOptions', mapped);
        else state.lastLoadedAt = Date.now(); // обновим таймштамп, чтобы TTL работал

      } finally {
        commit('setLoading', false);
        commit('setInFlight', null);
      }
    },
    invalidate({ commit }) { commit('invalidate'); },
  }
};